import { AuthGuardService } from 'src/app/auth-guard.service';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommissionDetailsSearchComponent } from './commission-details-search/commission-details-search.component';
import { EvaluationTrackingSearchComponent } from './evaluation-tracking/evaluation-tracking.component';
import { EndorsementInquirySearchComponent } from './endorsement-inquiry-search/endorsement-inquiry-search.component';

const routes: Routes = [
  {
    path: 'search-commission-details',
    component: CommissionDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-contest-and-incentive',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-contest',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-team-contest/:agentId/:agenName',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-incentive',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-team-incentive/:agentId/:agenName',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-evaluation',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'endorsement-inquiry',
    component: EndorsementInquirySearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class CompensationRoutingModule {}
